import { render, staticRenderFns } from "./exchangeStudents.vue?vue&type=template&id=1164db6c&"
import script from "./exchangeStudents.vue?vue&type=script&lang=js&"
export * from "./exchangeStudents.vue?vue&type=script&lang=js&"
import style0 from "./exchangeStudents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports